import {
  installmentTypesService,
  type InstallmentType,
  type ProductType,
} from '@/services';
import { useQuery } from '@tanstack/react-query';

export function useInstallmentTypes(
  productType: ProductType | undefined,
  isBusiness = false
) {
  return useQuery<InstallmentType[], Error>({
    queryKey: ['installment-types', isBusiness ? 'business' : productType],
    queryFn: async () => {
      if (!isBusiness && !productType) {
        throw new Error('Tipo de produto não informado');
      }

      const response = isBusiness
        ? await installmentTypesService.getBusinessInstallmentTypes()
        : await installmentTypesService.getInstallmentTypes(productType!);

      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar tipos de parcelamento'
        );
      }

      return response.data;
    },
    enabled: isBusiness || !!productType,
    staleTime: 5 * 60 * 1000, // 5 minutos
  });
}
